const module = {
  config: {
    name: 'master-data',
    icon: 'ri-database-2-line',
    desc: 'PMIS Infrastruktur II',
    layout: true
  },
  routes: [
    { name: 'projects', label: 'Daftar Proyek', icon: null, path: '/projects', component: () => import('./projects.vue') },
    { name: 'owner', label: 'Owner', icon: null, path: '/owner', component: () => import('./owners.vue') },
    { name: 'risk_register_categories', label: 'Kategori Critical Risk', icon: null, path: '/risk_register_categories', component: () => import('./risk_register_categories.vue') },
    { name: 'issue_log_categories', label: 'Kategori Issue Log', icon: null, path: '/issue_log_categories', component: () => import('./issue_log_categories.vue') },
    { name: 'contract_log_categories', label: 'Kategori Dokumen', icon: null, path: '/contract_log_categories', component: () => import('./contract_log_categories.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/master-data/_index.js